var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg260(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 64,
    viewBox: "0 0 76 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 52V50H43V52H27Z",
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52C43.394 52 43.7841 51.9224 44.1481 51.7716C44.512 51.6209 44.8427 51.3999 45.1213 51.1213C45.3999 50.8427 45.6209 50.512 45.7716 50.148C45.9224 49.7841 46 49.394 46 49C46 48.606 45.9224 48.2159 45.7716 47.8519C45.6209 47.488 45.3999 47.1573 45.1213 46.8787C44.8427 46.6001 44.512 46.3791 44.1481 46.2284C43.7841 46.0776 43.394 46 43 46L43 47.9976C43.1316 47.9976 43.262 48.0235 43.3836 48.0739C43.5052 48.1243 43.6157 48.1981 43.7088 48.2912C43.8019 48.3843 43.8757 48.4948 43.9261 48.6164C43.9765 48.738 44.0024 48.8684 44.0024 49C44.0024 49.1316 43.9765 49.262 43.9261 49.3836C43.8757 49.5052 43.8019 49.6157 43.7088 49.7088C43.6157 49.8019 43.5052 49.8757 43.3836 49.9261C43.262 49.9765 43.1316 50.0024 43 50.0024V52Z",
    fill: "#E3E3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53V55H47V53H27Z",
    fill: "#E3E3E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53C47.394 53 47.7841 53.0776 48.1481 53.2284C48.512 53.3791 48.8427 53.6001 49.1213 53.8787C49.3999 54.1573 49.6209 54.488 49.7716 54.8519C49.9224 55.2159 50 55.606 50 56C50 56.394 49.9224 56.7841 49.7716 57.1481C49.6209 57.512 49.3999 57.8427 49.1213 58.1213C48.8427 58.3999 48.512 58.6209 48.1481 58.7716C47.7841 58.9224 47.394 59 47 59L47 57.0024C47.1316 57.0024 47.262 56.9765 47.3836 56.9261C47.5052 56.8757 47.6157 56.8019 47.7088 56.7088C47.8019 56.6157 47.8757 56.5052 47.9261 56.3836C47.9765 56.262 48.0024 56.1316 48.0024 56C48.0024 55.8684 47.9765 55.738 47.9261 55.6164C47.8757 55.4948 47.8019 55.3843 47.7088 55.2912C47.6157 55.1981 47.5052 55.1243 47.3836 55.0739C47.262 55.0235 47.1316 54.9976 47 54.9976V53Z",
    fill: "#E3E3E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56V58H41V56H27Z",
    fill: "#E3E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41 56C41.394 56 41.7841 56.0776 42.1481 56.2284C42.512 56.3791 42.8427 56.6001 43.1213 56.8787C43.3999 57.1573 43.6209 57.488 43.7716 57.8519C43.9224 58.2159 44 58.606 44 59C44 59.394 43.9224 59.7841 43.7716 60.1481C43.6209 60.512 43.3999 60.8427 43.1213 61.1213C42.8427 61.3999 42.512 61.6209 42.148 61.7716C41.7841 61.9224 41.394 62 41 62L41 60.0024C41.1316 60.0024 41.262 59.9765 41.3836 59.9261C41.5052 59.8757 41.6157 59.8019 41.7088 59.7088C41.8019 59.6157 41.8757 59.5052 41.9261 59.3836C41.9765 59.262 42.0024 59.1316 42.0024 59C42.0024 58.8684 41.9765 58.738 41.9261 58.6164C41.8757 58.4948 41.8019 58.3843 41.7088 58.2912C41.6157 58.1981 41.5052 58.1243 41.3836 58.0739C41.262 58.0235 41.1316 57.9976 41 57.9976V56Z",
    fill: "#E3E3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_407_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 32C48 40.8366 40.8366 48 32 48C23.1634 48 16 40.8366 16 32C16 23.1634 23.1634 16 32 16C40.8366 16 48 23.1634 48 32Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 36C60 42.6274 54.6274 48 48 48C41.3726 48 36 42.6274 36 36C36 29.3726 41.3726 24 48 24C54.6274 24 60 29.3726 60 36Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 40H48V48H32V40Z",
    fill: "#EDEDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_407_82",
    x: 0,
    y: 0,
    width: 76,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_407_82"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg260);
export default __webpack_public_path__ + "static/media/260.5be438681d5f5017c8658557379e8942.svg";
export { ForwardRef as ReactComponent };